/**
 * Type guard function that checks if a value is a string.
 * Returns true if the value is a string, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is a string, false otherwise
 */
export function IsNumber<T>(value: T): value is number & T {
  return typeof value === "number"
}
